import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectBasketcustomerConfig: "selectBasketcustomerConfig [Action]",
  selectBasketcustomerConfigLoading:
    "selectBasketcustomerConfigLoading [Action]",
  selectBasketcustomerConfigAsync: "selectBasketcustomerConfigAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  size: 100,
  total: 10000,
};

export const select_basketcustomer_config_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectBasketcustomerConfig:
      return {
        ...state,
        data: payload?.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0,
      };
    case actionTypes.selectBasketcustomerConfigLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectBasketcustomerConfigLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_basketcustomer_config",
    data: payload?.data ? payload.data : {},
    from: payload.from,
    size: payload.size,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectBasketcustomerConfig,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectBasketcustomerConfigLoading,
      payload: false,
    });
  }
}

export function* selectBasketcustomerConfig() {
  yield takeLatest(actionTypes.selectBasketcustomerConfigAsync, handleWorker);
}
